import { useEffect, useState } from 'react';

import { getCodeKeyMap } from '../utils/keyboardUtils';

export function useCodeKeyMap(): Record<string, string> {
  const [codeKeyMap, setCodeKeyMap] = useState({});

  useEffect(() => {
    let isMounted = true;
    const asyncGetMap = async () => {
      const map = await getCodeKeyMap();
      if (isMounted) {
        setCodeKeyMap(map);
      }
    };

    asyncGetMap();

    return () => {
      isMounted = false;
    };
  }, []);

  return codeKeyMap;
}
